export const IPOCANCEL_DATA = "IPOMASTERBANK_DATA";
export const IPOCANCEL_ERROR_DATA = "IPOMASTERBANK_ERROR_DATA";
export const IPOCANCEL_HIDE_ERROR_DATA = "IPOMASTERBANK_HIDE_ERROR_DATA";
export const IPOCANCEL_START_LOADER = "IPOMASTERBANK_START_LOADER";
export const IPOCANCEL_STOP_LOADER = "IPOMASTERBANK_STOP_LOADER";
